import moment from 'moment-timezone';
import { R } from '@core/utils/r';
import { TimeInput, toMoment, timeRange } from '@core/utils/time';

export function getMonths() {
  return moment.months();
}

export function getShortMonths() {
  return moment.monthsShort();
}

export function getNYears(n: number, startFrom?: TimeInput) {
  const startDate = toMoment(startFrom);
  const endDate = startDate.clone().add(n, 'years');
  return timeRange(startDate, endDate, 'years').map(m => toMoment(m).format('YYYY'));
}

export function getCalendarObjectLabel(objectType: string) {
  switch (objectType) {
    case 'deal':
      return 'Deal';
    case 'timeMaterial':
      return 'Work Order';
    case 'project':
      return 'Project';
  }
}

export function getStatusIcon(status: string) {
  if (status === 'accepted') {
    return 'fa-check-circle text-success';
  } else if (status === 'declined') {
    return 'fa-times-circle text-danger';
  } else {
    return 'fa-question-circle text-muted';
  }
}

export function getEventStatusIcon(status?: string) {
  if (!status) return '';
  switch (status.toLowerCase()) {
    case 'accepted':
      return '✓ ';
    case 'declined':
      return '✗ ';
    case 'rescheduled':
      return '⟳ ';
    case 'maybe':
    case 'tentative':
      return '? ';
    default:
      return '';
  }
}
